import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const checkSwitch: SxStyle = {};

export const text: SxStyle = {
  color: (p) => p.palette.grey[500],
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[500],
};
